import { ERRORS } from '@ezugi/constants';
import { GameError } from '@ezugi/types';

import { Volume } from '../store/reducers/media';
import { EvoPlayer } from '../views/GameVideo/EvoPlayer/player';
import VideoPlayer from '../views/GameVideo/NanoPlayer/VideoPlayer';

const { CODES, DENIED_CAMERA_ACCESS, DENIED_MICROPHONE_ACCESS, AGORA_ERROR } = ERRORS;

const updateEvoVideoVolume = (volume: Volume) => {
  const { value, muted } = volume;

  if (!EvoPlayer.initialized) return;

  EvoPlayer.muted?.set(muted);

  if (value !== undefined) {
    EvoPlayer.volume?.set(Number(value) / 100);
  }
};

export const updateVideoVolume = (volume: Volume) => {
  const { value, muted } = volume;

  // nanoplayer logic
  if (muted) {
    VideoPlayer.mute();
  } else {
    VideoPlayer.unmute();
  }

  VideoPlayer.volume(Number(value) / 100);

  // Evoplayer - guard for autoplay policy
  if (EvoPlayer.canPlaySound) {
    updateEvoVideoVolume(volume);
  }
};

export const getCameraAndMicPermission = ({ setUserAccepted, setError }: {
  setUserAccepted: (value: boolean) => void
  setError: (err: GameError) => void
}) => {
  const handleMediaError = (e: Error) => {
    // theres's only a generic error message now; there can be specific messages in the future
    const errorIntlKeys = {
      title: 'errors.camera_access_rejection_title',
      description: 'errors.camera_access_rejection_desc',
    };
    const genericError = {
      code: CODES[AGORA_ERROR],
      ...errorIntlKeys,
    };

    if (e.name === 'OverconstrainedError') {
      setError(genericError);
      return;
    }

    const deviceNotAllowedError = (devices: MediaDeviceInfo[]) => {
      const micAllowed = !!devices.filter(({ kind, label }) => kind === 'audioinput' && label).length;
      const deviceErr = {
        code: micAllowed ? CODES[DENIED_CAMERA_ACCESS] : CODES[DENIED_MICROPHONE_ACCESS],
        ...errorIntlKeys,
      };

      setError(deviceErr);
    };

    const otherError = () => {
      setError(genericError);
    };

    navigator.mediaDevices.enumerateDevices()
      .then(deviceNotAllowedError)
      .catch(otherError);
  };

  navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: true })
    .then((stream) => {
      stream.getTracks().forEach((track) => track.stop());
      setUserAccepted(true);
    }).catch(handleMediaError);
};
